var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInformation1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 202 203",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M184.762 55.74c-.969-7.57-2.858-14.83-6.833-21.443-7.331-12.288-20.595-19.713-34.007-23.478-11.254-3.156-23.377-4.068-34.603-.807-12.323 3.58-22.665 11.82-33.762 18.28a175.608 175.608 0 0 1-25.362 11.969c-7.066 2.716-16.045 4.237-21.853 9.394a58.416 58.416 0 0 0-9.385 10.754C8.113 76.272 4.6 96.538 6.256 115.456c1.17 13.179 4.779 26.516 12.862 36.955 11.362 14.653 30.868 21.872 49.273 20.052 20.9-2.066 40.695-14.604 61.467-11.594 10.342 1.497 20.237 6.832 30.639 5.839 10.254-.976 19.028-8.07 25.214-16.323 4.959-6.63 8.259-14.648 8.565-23.001.333-9.035-3.742-17.275-5.788-25.903-3.557-15.08-1.777-30.507-3.726-45.74z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M184.762 55.74c-.969-7.57-2.858-14.83-6.833-21.443-7.331-12.288-20.595-19.713-34.007-23.478-11.254-3.156-23.377-4.068-34.603-.807-12.323 3.58-22.665 11.82-33.762 18.28a175.608 175.608 0 0 1-25.362 11.969c-7.066 2.716-16.045 4.237-21.853 9.394a58.416 58.416 0 0 0-9.385 10.754C8.113 76.272 4.6 96.538 6.256 115.456c1.17 13.179 4.779 26.516 12.862 36.955 11.362 14.653 30.868 21.872 49.273 20.052 20.9-2.066 40.695-14.604 61.467-11.594 10.342 1.497 20.237 6.832 30.639 5.839 10.254-.976 19.028-8.07 25.214-16.323 4.959-6.63 8.259-14.648 8.565-23.001.333-9.035-3.742-17.275-5.788-25.903-3.557-15.08-1.777-30.507-3.726-45.74z",
    opacity: 0.7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.386,
    d: "M134.798 127.457h58.658v-2.219h-58.658v2.219zM137.519 187.486h53.216v-59.965h-53.216v59.965z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.386,
    d: "M139.436 143.324h49.45v-13.01h-49.45v13.01z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.386,
    d: "M161.772 138.013h4.943v-2.397h-4.943v2.397z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.386,
    d: "M139.436 159.76h49.45v-13.01h-49.45v13.01z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.386,
    d: "M161.772 154.453h4.943v-2.397h-4.943v2.397z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.386,
    d: "M139.436 176.268h49.45v-13.01h-49.45v13.01z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.386,
    d: "M161.772 170.962h4.943v-2.397h-4.943v2.397z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M166.579 99.004c.599.262 2.066.23 2.066.23s-.314-.965-.342-1.025c-.322-.674-1.338-1.792-2.166-1.68a.99.99 0 0 0-.828.833c-.021.138-.013.28.024.415a2.093 2.093 0 0 0 1.246 1.227zM181.398 99.326s.265-.976.273-1.04c.105-.743-.132-2.236-.884-2.604a.986.986 0 0 0-1.346.606 2.094 2.094 0 0 0 .357 1.71c.358.541 1.596 1.328 1.6 1.328z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M185.775 93.992c-.832-.09-1.821 1.053-2.122 1.735-.028.06-.33 1.033-.314 1.033a22.399 22.399 0 0 0-1.551 1.97 17.264 17.264 0 0 0-1.089 1.738 12.778 12.778 0 0 0-.933 2.107v-.961c-.096-.742-.715-2.122-1.539-2.276a.985.985 0 0 0-1.034.537c-.062.124-.097.26-.104.4a2.088 2.088 0 0 0 .804 1.553c.47.404 1.769.827 1.873.86a18.488 18.488 0 0 0-.55 2.276c-.077.452-.145.904-.205 1.36v-.428c-.097-.743-.716-2.123-1.536-2.272a.989.989 0 0 0-.779.209.976.976 0 0 0-.258.323.977.977 0 0 0-.104.4 2.076 2.076 0 0 0 .804 1.554 6.491 6.491 0 0 0 1.816.839c-.02.178-.044.351-.064.529-.101.839-.197 1.682-.318 2.502-.04.29-.092.573-.144.859v-.375c-.097-.743-.716-2.119-1.54-2.272a.978.978 0 0 0-1.033.533.973.973 0 0 0-.104.399 2.076 2.076 0 0 0 .804 1.554c.542.36 1.138.632 1.764.807-.06.29-.12.581-.193.859-.056.186-.092.372-.156.557-.065.186-.121.371-.177.553-.125.347-.254.706-.402 1.041-.089.23-.177.452-.266.674.045-.286.121-.851.121-.9a3.873 3.873 0 0 0-.514-1.876 1.038 1.038 0 0 0-.349-.823 1.02 1.02 0 0 0-.857-.239c-.804.218-1.319 1.639-1.359 2.389 0 .045.028.525.053.828-.045-.174-.081-.347-.125-.529-.084-.359-.181-.714-.281-1.094a38.985 38.985 0 0 0-.165-.556c-.057-.186-.133-.376-.197-.565a19.21 19.21 0 0 0-.535-1.312 6.499 6.499 0 0 0 1.861-.702 2.082 2.082 0 0 0 .909-1.489.99.99 0 0 0-1.07-1.017c-.832.093-1.551 1.42-1.7 2.155 0 .044-.06.585-.08.88-.121-.263-.237-.521-.366-.783-.37-.751-.772-1.497-1.165-2.248-.121-.226-.238-.456-.358-.686.112-.028 1.435-.335 1.929-.718a2.076 2.076 0 0 0 .908-1.489.994.994 0 0 0-.66-.964.963.963 0 0 0-.409-.053c-.828.093-1.551 1.42-1.7 2.155 0 .052-.08.827-.088 1.025a32.522 32.522 0 0 1-.752-1.522 17.28 17.28 0 0 1-.804-2.114c.052 0 1.435-.327 1.942-.718a2.076 2.076 0 0 0 .908-1.49.997.997 0 0 0-.66-.963.986.986 0 0 0-.409-.053c-.828.092-1.552 1.42-1.7 2.15 0 .049-.065.642-.085.924h-.044a12.515 12.515 0 0 1-.426-2.239 13.68 13.68 0 0 1-.08-1.21 6.627 6.627 0 0 0 1.961-.493 2.076 2.076 0 0 0 1.065-1.384.99.99 0 0 0-.952-1.126c-.837 0-1.697 1.239-1.926 1.953 0 .036-.096.444-.152.743v-.525c0-.638.04-1.21.08-1.731.024-.29.052-.557.08-.807a6.636 6.636 0 0 0 1.508-1.34 2.074 2.074 0 0 0 .309-1.719.996.996 0 0 0-.962-.658.996.996 0 0 0-.401.097c-.739.404-.936 1.885-.803 2.623 0 .065.289 1.045.301 1.037a40.22 40.22 0 0 0-.096.77 24.197 24.197 0 0 0-.117 1.732c-.023.686-.007 1.373.048 2.058.059.766.186 1.525.378 2.268v.028c-.133-.21-.518-.775-.555-.807-.486-.565-1.764-1.372-2.532-1.045a.998.998 0 0 0-.531.606 1.003 1.003 0 0 0 .093.802 2.071 2.071 0 0 0 1.515.86c.623.089 1.93-.291 2.034-.323.22.753.488 1.49.804 2.207.181.404.374.832.575 1.247l-.245-.351c-.491-.569-1.765-1.372-2.533-1.045a.988.988 0 0 0-.438 1.408 2.062 2.062 0 0 0 1.516.86c.671 0 1.337-.104 1.977-.307.081.158.157.319.233.476.402.759.76 1.514 1.114 2.264.124.262.237.529.349.807a6.848 6.848 0 0 0-.213-.306c-.486-.565-1.764-1.372-2.532-1.046a1.004 1.004 0 0 0-.57 1.021.996.996 0 0 0 .132.392 2.076 2.076 0 0 0 1.515.855 6.357 6.357 0 0 0 1.926-.29c.108.274.217.549.309.807.056.185.129.363.177.553l.157.557c.084.359.172.726.249 1.081.052.242.1.476.149.71-.121-.262-.366-.779-.402-.807-.402-.633-1.536-1.614-2.344-1.416a.995.995 0 0 0-.647 1.327 2.082 2.082 0 0 0 1.371 1.078 6.748 6.748 0 0 0 2.046 0c.08.403.152.771.213 1.13.136.787.241 1.493.321 2.094h-3.292v6.949h8.658v-6.961h-3.348c.217-.484.454-1.033.703-1.642.153-.376.31-.779.467-1.191.156.032 1.443.295 2.041.158a2.06 2.06 0 0 0 1.443-.969.981.981 0 0 0 .035-.808.986.986 0 0 0-.577-.564c-.804-.27-2.01.634-2.444 1.239a9.41 9.41 0 0 0-.402.718c.064-.169.129-.335.189-.508.129-.347.245-.698.37-1.07.056-.185.108-.371.165-.557.056-.185.1-.403.148-.581.109-.456.197-.92.274-1.392.618.25 1.272.401 1.937.448a2.048 2.048 0 0 0 1.575-.738.996.996 0 0 0-.329-1.441c-.744-.383-2.074.327-2.605.855-.032.033-.369.452-.55.691.044-.287.088-.569.124-.856.105-.831.181-1.679.266-2.518.024-.258.052-.517.08-.775.104.041 1.379.517 2.01.472.554-.04 1.254-.242 1.575-.738a1.003 1.003 0 0 0-.022-1.169 1 1 0 0 0-.311-.272c-.74-.403-2.074.323-2.601.852-.04.04-.526.649-.639.807.06-.569.125-1.134.209-1.687.113-.748.274-1.488.482-2.215.049 0 1.375.52 2.01.476a2.057 2.057 0 0 0 1.576-.739.995.995 0 0 0-.33-1.44c-.744-.384-2.074.323-2.605.851-.036.036-.401.501-.574.722h-.041c.229-.727.522-1.432.877-2.106.189-.371.402-.718.595-1.05.598.32 1.242.548 1.909.675a2.083 2.083 0 0 0 1.648-.565.996.996 0 0 0-.173-1.465c-.7-.464-2.098.093-2.681.56-.032.025-.326.32-.539.538.097-.15.189-.307.286-.444.345-.529.699-.993 1.017-1.4.18-.23.349-.432.506-.622.68.006 1.358-.09 2.01-.286a2.068 2.068 0 0 0 1.206-1.26.993.993 0 0 0-.925-1.238zm-9.2 22.408a53.109 53.109 0 0 1-.836 1.836h-.88a30.797 30.797 0 0 0-.402-2.187c-.077-.404-.169-.807-.266-1.247.39-.159.771-.34 1.142-.541a7.249 7.249 0 0 0 1.668 1.078c-.129.367-.277.722-.426 1.061z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.773,
    d: "M11.622 128.151l4.662 44.845M15.533 164.412l-2.115-2.239"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.386,
    d: "M14.061 162.843a2.433 2.433 0 0 0-.84-1.8c-.542-.484-3.4-1.691-3.67-.682-.293 1.098 2.63 3.253 4.51 2.482z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.193,
    d: "M14.061 162.843l-2.717-1.699"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.773,
    d: "M16.063 169.513l-2.114-2.24"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.386,
    d: "M14.592 167.943a2.429 2.429 0 0 0-.84-1.799c-.543-.485-3.4-1.691-3.67-.682-.293 1.097 2.629 3.252 4.51 2.481z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.193,
    d: "M14.592 167.944l-2.717-1.699"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.773,
    d: "M14.238 151.968l-2.114-2.24"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.386,
    d: "M12.767 150.398a2.433 2.433 0 0 0-.84-1.8c-.542-.488-3.4-1.691-3.67-.682-.293 1.098 2.63 3.252 4.51 2.482z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.193,
    d: "M12.767 150.398l-2.717-1.699"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.773,
    d: "M14.769 157.068l-2.114-2.239"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.386,
    d: "M13.298 155.498a2.429 2.429 0 0 0-.84-1.799c-.543-.489-3.4-1.691-3.67-.682-.293 1.097 2.645 3.252 4.51 2.481z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.193,
    d: "M13.298 155.498l-2.717-1.699"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.773,
    d: "M13.378 143.683l-2.114-2.244"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.386,
    d: "M11.907 142.113a2.407 2.407 0 0 0-.844-1.8c-.543-.488-3.396-1.691-3.666-.682-.293 1.098 2.63 3.253 4.51 2.482z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.193,
    d: "M11.907 142.113l-2.717-1.699"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.773,
    d: "M12.514 135.362l-2.114-2.244"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.386,
    d: "M11.03 133.792a2.407 2.407 0 0 0-.843-1.8c-.543-.488-3.396-1.695-3.666-.682-.285 1.098 2.637 3.253 4.51 2.482z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.193,
    d: "M11.043 133.792l-2.721-1.703"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.773,
    d: "M15.179 161.394l1.603-2.631"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.386,
    d: "M16.292 159.554a2.43 2.43 0 0 1 .454-1.929c.43-.589 2.975-2.361 3.449-1.428.514 1.025-1.901 3.724-3.903 3.357z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.193,
    d: "M16.292 159.554l2.448-2.348"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.773,
    d: "M13.78 147.972l1.608-2.631"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.386,
    d: "M14.898 146.132a2.429 2.429 0 0 1 .454-1.933c.43-.589 2.974-2.36 3.448-1.428.515 1.013-1.9 3.728-3.902 3.361z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.193,
    d: "M14.898 146.132l2.447-2.348"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.773,
    d: "M13.17 142.077l1.607-2.631"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.386,
    d: "M14.287 140.237a2.43 2.43 0 0 1 .45-1.937c.434-.589 2.978-2.361 3.448-1.429.515 1.013-1.9 3.729-3.898 3.366z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.193,
    d: "M14.287 140.237l2.447-2.349"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.773,
    d: "M12.269 133.429l1.608-2.631"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.386,
    d: "M13.386 131.589a2.433 2.433 0 0 1 .454-1.937c.43-.589 2.975-2.361 3.449-1.429.514 1.013-1.901 3.729-3.903 3.366z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.193,
    d: "M13.386 131.589l2.448-2.349"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.386,
    d: "M11.582 127.9a2.43 2.43 0 0 1 .454-1.936c.43-.59 2.974-2.361 3.448-1.429.515 1.013-1.9 3.729-3.902 3.365z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.193,
    d: "M11.582 127.901l2.447-2.349"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.386,
    d: "M11.726 128.001a2.399 2.399 0 0 1-1.873-.641c-.534-.493-2.01-3.228-1.053-3.596 1.057-.419 3.497 2.28 2.926 4.237z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.193,
    d: "M11.726 128.002l-2.07-2.692"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.773,
    d: "M23.917 134.325l-4.634 44.849M20.307 170.619l-1.607-2.627"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.386,
    d: "M19.19 168.779a2.434 2.434 0 0 0-.454-1.933c-.434-.589-2.978-2.357-3.453-1.429-.51 1.017 1.906 3.729 3.907 3.362z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.193,
    d: "M19.19 168.779l-2.311-2.224"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.773,
    d: "M21.594 158.174l-1.608-2.631"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.386,
    d: "M20.476 156.334a2.433 2.433 0 0 0-.454-1.937c-.43-.59-2.978-2.361-3.448-1.429-.515 1.025 1.9 3.733 3.902 3.366z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.193,
    d: "M20.476 156.333l-2.31-2.227"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.773,
    d: "M21.067 163.275l-1.608-2.631"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.386,
    d: "M19.95 161.435a2.433 2.433 0 0 0-.454-1.933c-.434-.59-2.979-2.361-3.453-1.429-.51 1.013 1.905 3.729 3.907 3.362z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.193,
    d: "M19.95 161.435l-2.311-2.228"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.773,
    d: "M22.45 149.889l-1.608-2.631"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.386,
    d: "M21.332 148.049a2.428 2.428 0 0 0-.454-1.937c-.43-.585-2.978-2.356-3.448-1.424-.515 1.013 1.9 3.729 3.902 3.361z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.193,
    d: "M21.332 148.049l-2.31-2.227"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.773,
    d: "M23.31 141.569l-1.608-2.631"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.386,
    d: "M22.193 139.728a2.428 2.428 0 0 0-.455-1.937c-.43-.589-2.978-2.356-3.448-1.424-.515 1.013 1.9 3.725 3.903 3.361z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.193,
    d: "M22.193 139.728L19.88 137.5"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.773,
    d: "M20.577 167.592l2.114-2.239"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.386,
    d: "M22.048 166.022a2.428 2.428 0 0 1 .84-1.799c.542-.485 3.396-1.695 3.67-.686.293 1.097-2.63 3.256-4.51 2.485z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.193,
    d: "M22.048 166.023l2.878-1.792"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.773,
    d: "M21.963 154.171l2.115-2.24"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.386,
    d: "M23.435 152.601a2.428 2.428 0 0 1 .86-1.8c.542-.488 3.396-1.694 3.67-.686.273 1.098-2.645 3.257-4.53 2.486z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.193,
    d: "M23.435 152.601l2.877-1.792"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.773,
    d: "M22.574 148.271l2.114-2.24"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.386,
    d: "M24.045 146.701a2.425 2.425 0 0 1 .84-1.8c.543-.484 3.397-1.695 3.666-.686.298 1.102-2.624 3.257-4.506 2.486z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.193,
    d: "M24.045 146.701l2.878-1.791"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.773,
    d: "M23.467 139.627l2.114-2.243"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.386,
    d: "M24.938 138.054a2.436 2.436 0 0 1 .84-1.816c.542-.485 3.396-1.695 3.67-.682.293 1.113-2.625 3.268-4.51 2.498z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.193,
    d: "M24.938 138.053l2.878-1.791"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.386,
    d: "M23.929 134.075a2.432 2.432 0 0 1 .84-1.8c.543-.488 3.396-1.695 3.67-.686.277 1.098-2.625 3.257-4.51 2.486z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.193,
    d: "M23.929 134.075l2.878-1.792"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.386,
    d: "M24.05 134.22a2.377 2.377 0 0 1-1.697-1.025c-.426-.593-1.322-3.567-.293-3.733 1.117-.201 2.95 2.942 1.99 4.758z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.193,
    d: "M24.05 134.2l-1.476-3.059"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.773,
    d: "M18.603 116.061v56.717M18.652 164.251l-1.873-2.449"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.386,
    d: "M17.35 162.536a2.433 2.433 0 0 0-.652-1.88c-.49-.537-3.215-2.018-3.577-1.058-.406 1.058 2.275 3.507 4.228 2.938z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.193,
    d: "M17.35 162.536l-2.529-1.974"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.773,
    d: "M18.652 153.589l-1.873-2.445"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.386,
    d: "M17.35 151.879a2.431 2.431 0 0 0-.652-1.881c-.49-.541-3.215-2.038-3.577-1.061-.406 1.061 2.275 3.511 4.228 2.942z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.193,
    d: "M17.35 151.879l-2.529-1.978"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.773,
    d: "M18.652 141.08l-1.873-2.45"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.386,
    d: "M17.35 139.365a2.433 2.433 0 0 0-.652-1.88c-.49-.541-3.215-2.018-3.577-1.062-.406 1.062 2.275 3.511 4.228 2.942z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.193,
    d: "M17.35 139.365l-2.529-1.977"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.773,
    d: "M18.652 132.747l-1.873-2.449"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.386,
    d: "M17.35 131.032a2.426 2.426 0 0 0-.652-1.877c-.49-.54-3.215-2.037-3.577-1.061-.406 1.061 2.275 3.511 4.228 2.938z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.193,
    d: "M17.35 131.032l-2.529-1.973"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.773,
    d: "M18.652 124.382l-1.873-2.45"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.386,
    d: "M17.35 122.667a2.43 2.43 0 0 0-.652-1.877c-.49-.541-3.215-2.038-3.577-1.061-.406 1.061 2.275 3.511 4.228 2.938z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.193,
    d: "M17.35 122.667l-2.529-1.974"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.773,
    d: "M18.607 167.504l1.873-2.45"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.386,
    d: "M19.91 165.789a2.434 2.434 0 0 1 .65-1.877c.491-.54 3.216-2.038 3.578-1.061.406 1.061-2.255 3.511-4.229 2.938z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.193,
    d: "M19.91 165.789l2.676-2.079"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.773,
    d: "M18.607 150.551l1.873-2.446"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.386,
    d: "M19.91 148.84a2.428 2.428 0 0 1 .65-1.88c.491-.541 3.216-2.018 3.578-1.062.406 1.062-2.255 3.511-4.228 2.942z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.193,
    d: "M19.91 148.84l2.676-2.082"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.773,
    d: "M18.607 142.186l1.873-2.45"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.386,
    d: "M19.91 140.471a2.436 2.436 0 0 1 .65-1.877c.491-.54 3.216-2.017 3.578-1.061.406 1.061-2.255 3.511-4.229 2.938z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.193,
    d: "M19.91 140.471l2.676-2.078"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.773,
    d: "M18.607 131.129l1.873-2.449"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.386,
    d: "M19.91 129.414a2.434 2.434 0 0 1 .65-1.877c.491-.54 3.216-2.038 3.578-1.061.406 1.061-2.255 3.511-4.229 2.938z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.193,
    d: "M19.91 129.414l2.676-2.082"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.773,
    d: "M18.607 122.433l1.873-2.45"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.386,
    d: "M19.91 120.722a2.435 2.435 0 0 1 .65-1.881c.491-.54 3.216-2.037 3.578-1.061.406 1.061-2.255 3.527-4.228 2.942z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.193,
    d: "M19.91 120.722l2.676-2.082"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.386,
    d: "M18.499 116.868a2.404 2.404 0 0 1 .647-1.877c.49-.54 3.215-2.017 3.581-1.061.406 1.057-2.279 3.507-4.228 2.938z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.193,
    d: "M18.499 116.864l2.677-2.082"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.386,
    d: "M18.628 116.981a2.409 2.409 0 0 1-1.793-.847c-.483-.545-1.68-3.414-.675-3.685 1.093-.294 3.24 2.643 2.468 4.532z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.193,
    d: "M18.627 116.981l-1.78-2.894"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.386,
    d: "M20.93 187.487h-5.984l-.748-15.169h7.48l-.748 15.169z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.386,
    d: "M46.433 71.342h-35.94V13.898H54.99v57.444h-6.222"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.386,
    d: "M53.379 15.98H12.108v53.28h41.27V15.98z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.386,
    d: "M20.376 30.572c.73.679 1.51 1.3 2.335 1.86 9.337 6.36 25.173 3.35 30.507 12.385M14.877 16.199c-.223 2.38.046 4.78.792 7.05a17.338 17.338 0 0 0 3.541 6.141M18.414 45.548c4.554-2.421 10.45-4.128 13.47.775 3.5 5.694-12.674 15.737-12.674 22.928M12.213 49.672a39.545 39.545 0 0 1 4.943-3.422M33.716 16.199s6 9.374 19.67 6.86M35.508 25.404a5.529 5.529 0 0 1-1.345 4.324 5.478 5.478 0 0 1-7.23.877 5.517 5.517 0 0 1-2.213-3.218 5.536 5.536 0 0 1 .467-3.881 5.502 5.502 0 0 1 2.912-2.596 5.474 5.474 0 0 1 3.895-.006 5.501 5.501 0 0 1 2.92 2.587M49.215 33.522a2.602 2.602 0 0 1-1.605 2.39 2.575 2.575 0 0 1-2.813-.573 2.598 2.598 0 0 1-.552-2.827 2.577 2.577 0 0 1 4.22-.832 2.592 2.592 0 0 1 .75 1.842v0zM49.25 51.023a10.548 10.548 0 0 1 3.984 2.018M39.351 69.292a10.72 10.72 0 0 1-3.179-5.462c-.487-2.1-.332-4.3.446-6.31a10.703 10.703 0 0 1 3.914-4.957 10.638 10.638 0 0 1 6.018-1.874h.615M129.601 187.487h63.907M6.61 187.487h119.775"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M159.155 17.397H78.033v150.878h81.122V17.397z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fill: "#DEDEDE",
    d: "M159.155 142.545H78.033v25.729h81.122v-25.729z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M161.591 47.08a1.005 1.005 0 0 0 1-1.005v-10.06a1.005 1.005 0 0 0-1-1.004.963.963 0 0 0-.189 0v-18.8a6.5 6.5 0 0 0-1.892-4.586 6.445 6.445 0 0 0-4.567-1.9H83.74a6.436 6.436 0 0 0-4.57 1.899 6.486 6.486 0 0 0-1.893 4.586v151.846c0 1.721.681 3.372 1.893 4.589a6.45 6.45 0 0 0 4.57 1.9h71.203a6.448 6.448 0 0 0 4.567-1.902 6.5 6.5 0 0 0 1.892-4.587V75.679a.978.978 0 0 0 .189 0 1.005 1.005 0 0 0 1-1.009V64.63a1.005 1.005 0 0 0-1-1.004.963.963 0 0 0-.189.02V61.37c.062.013.125.02.189.02a1.008 1.008 0 0 0 1-1.005V50.321a1.008 1.008 0 0 0-1-1.005.962.962 0 0 0-.189.02v-2.28a.974.974 0 0 0 .189.025zm-3.931 117.684H81.02V20.916h76.64v143.848z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.317,
    d: "M155.051 22.409h-6.354v3.498h6.354V22.41z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.28,
    d: "M153.653 22.409h-4.956v3.498h4.956V22.41zM155.936 23.39h-.897v1.54h.897v-1.54z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.341,
    d: "M83.91 23.494h-1.166V25.5h1.165v-2.006zM85.742 22.792h-1.166V25.5h1.166v-2.708zM87.571 21.956h-1.166V25.5h1.166v-3.544z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M155.851 27.852H82.253v19.419h73.598V27.852z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.386,
    d: "M100.855 30.649v14.257M119.609 30.649v14.257M138.367 30.649v14.257"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M160.739 75.68a.978.978 0 0 0 .189 0 1.01 1.01 0 0 0 1-1.009v-3.604l-4.931 8.728v84.969h-47.979l-5.543 9.781h50.801a6.449 6.449 0 0 0 4.57-1.9 6.504 6.504 0 0 0 1.893-4.589V75.679z",
    opacity: 0.15
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M111.403 72.517h-1.666v1.666h1.666v-1.666zM116.4 72.517h-1.665v1.666h1.665v-1.666zM119.732 72.517h-1.666v1.666h1.666v-1.666zM121.398 72.517h-1.666v1.666h1.666v-1.666zM123.064 72.517h-1.666v1.666h1.666v-1.666zM128.061 72.517h-1.665v1.666h1.665v-1.666zM129.727 72.517h-1.666v1.666h1.666v-1.666zM131.393 72.517h-1.666v1.666h1.666v-1.666zM111.403 74.183h-1.666v1.666h1.666v-1.666zM114.735 74.183h-1.666v1.666h1.666v-1.666zM116.4 74.183h-1.665v1.666h1.665v-1.666zM119.732 74.183h-1.666v1.666h1.666v-1.666zM124.73 74.183h-1.666v1.666h1.666v-1.666zM114.735 75.849h-1.666v1.665h1.666V75.85zM118.066 75.849h-1.665v1.665h1.665V75.85zM124.73 75.849h-1.666v1.665h1.666V75.85zM129.727 75.849h-1.666v1.665h1.666V75.85zM111.403 77.515h-1.666v1.665h1.666v-1.665zM121.398 77.515h-1.666v1.665h1.666v-1.665zM123.064 77.515h-1.666v1.665h1.666v-1.665zM126.396 77.515h-1.666v1.665h1.666v-1.665zM128.061 77.515h-1.665v1.665h1.665v-1.665zM114.735 79.18h-1.666v1.666h1.666V79.18zM121.398 79.18h-1.666v1.666h1.666V79.18zM124.73 79.18h-1.666v1.666h1.666V79.18zM129.727 79.18h-1.666v1.666h1.666V79.18zM114.735 80.846h-1.666v1.666h1.666v-1.666zM116.4 80.846h-1.665v1.666h1.665v-1.666zM118.066 80.846h-1.665v1.666h1.665v-1.666zM119.732 80.846h-1.666v1.666h1.666v-1.666zM123.064 80.846h-1.666v1.666h1.666v-1.666zM124.73 80.846h-1.666v1.666h1.666v-1.666zM126.396 80.846h-1.666v1.666h1.666v-1.666zM128.061 80.846h-1.665v1.666h1.665v-1.666zM129.727 80.846h-1.666v1.666h1.666v-1.666zM111.403 82.512h-1.666v1.666h1.666v-1.666zM114.735 82.512h-1.666v1.666h1.666v-1.666zM118.066 82.512h-1.665v1.666h1.665v-1.666zM121.398 82.512h-1.666v1.666h1.666v-1.666zM124.73 82.512h-1.666v1.666h1.666v-1.666zM128.061 82.512h-1.665v1.666h1.665v-1.666zM131.393 82.512h-1.666v1.666h1.666v-1.666zM111.403 84.178h-1.666v1.666h1.666v-1.666zM116.4 84.178h-1.665v1.666h1.665v-1.666zM123.064 84.178h-1.666v1.666h1.666v-1.666zM124.73 84.178h-1.666v1.666h1.666v-1.666zM126.396 84.178h-1.666v1.666h1.666v-1.666zM98.076 85.844h-1.665v1.666h1.665v-1.666zM101.408 85.844h-1.666v1.666h1.666v-1.666zM103.074 85.844h-1.666v1.666h1.666v-1.666zM106.406 85.844h-1.666v1.666h1.666v-1.666z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M108.071 85.844h-1.665v1.666h1.665v-1.666zM109.737 85.844h-1.666v1.666h1.666v-1.666zM114.735 85.844h-1.666v1.666h1.666v-1.666zM116.4 85.844h-1.665v1.666h1.665v-1.666zM118.066 85.844h-1.665v1.666h1.665v-1.666zM119.732 85.844h-1.666v1.666h1.666v-1.666zM123.064 85.844h-1.666v1.666h1.666v-1.666zM126.396 85.844h-1.666v1.666h1.666v-1.666zM128.061 85.844h-1.665v1.666h1.665v-1.666zM134.725 85.844h-1.666v1.666h1.666v-1.666zM139.722 85.844h-1.666v1.666h1.666v-1.666zM143.054 85.844h-1.666v1.666h1.666v-1.666zM144.72 85.844h-1.666v1.666h1.666v-1.666zM98.076 87.51h-1.665v1.666h1.665V87.51zM99.742 87.51h-1.666v1.666h1.666V87.51zM104.74 87.51h-1.666v1.666h1.666V87.51zM118.066 87.51h-1.665v1.666h1.665V87.51zM119.732 87.51h-1.666v1.666h1.666V87.51zM121.398 87.51h-1.666v1.666h1.666V87.51zM123.064 87.51h-1.666v1.666h1.666V87.51zM128.061 87.51h-1.665v1.666h1.665V87.51zM129.727 87.51h-1.666v1.666h1.666V87.51zM131.393 87.51h-1.666v1.666h1.666V87.51zM133.059 87.51h-1.666v1.666h1.666V87.51zM134.725 87.51h-1.666v1.666h1.666V87.51zM136.391 87.51h-1.666v1.666h1.666V87.51zM138.056 87.51h-1.665v1.666h1.665V87.51zM144.72 87.51h-1.666v1.666h1.666V87.51zM108.071 89.175h-1.665v1.666h1.665v-1.666zM109.737 89.175h-1.666v1.666h1.666v-1.666zM111.403 89.175h-1.666v1.666h1.666v-1.666zM113.069 89.175h-1.666v1.666h1.666v-1.666zM114.735 89.175h-1.666v1.666h1.666v-1.666zM116.4 89.175h-1.665v1.666h1.665v-1.666z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M118.066 89.175h-1.665v1.666h1.665v-1.666zM119.732 89.175h-1.666v1.666h1.666v-1.666zM124.73 89.175h-1.666v1.666h1.666v-1.666zM126.396 89.175h-1.666v1.666h1.666v-1.666zM128.061 89.175h-1.665v1.666h1.665v-1.666zM131.393 89.175h-1.666v1.666h1.666v-1.666zM138.056 89.175h-1.665v1.666h1.665v-1.666zM141.388 89.175h-1.666v1.666h1.666v-1.666zM143.054 89.175h-1.666v1.666h1.666v-1.666zM99.742 90.841h-1.666v1.666h1.666v-1.666zM113.069 90.841h-1.666v1.666h1.666v-1.666zM124.73 90.841h-1.666v1.666h1.666v-1.666zM129.727 90.841h-1.666v1.666h1.666v-1.666zM131.393 90.841h-1.666v1.666h1.666v-1.666zM133.059 90.841h-1.666v1.666h1.666v-1.666zM134.725 90.841h-1.666v1.666h1.666v-1.666zM136.391 90.841h-1.666v1.666h1.666v-1.666zM144.72 90.841h-1.666v1.666h1.666v-1.666zM98.076 92.507h-1.665v1.666h1.665v-1.666zM99.742 92.507h-1.666v1.666h1.666v-1.666zM103.074 92.507h-1.666v1.666h1.666v-1.666zM106.406 92.507h-1.666v1.666h1.666v-1.666z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M108.071 92.507h-1.665v1.666h1.665v-1.666zM111.403 92.507h-1.666v1.666h1.666v-1.666zM118.066 92.507h-1.665v1.666h1.665v-1.666zM121.398 92.507h-1.666v1.666h1.666v-1.666zM123.064 92.507h-1.666v1.666h1.666v-1.666zM126.396 92.507h-1.666v1.666h1.666v-1.666zM131.393 92.507h-1.666v1.666h1.666v-1.666zM136.391 92.507h-1.666v1.666h1.666v-1.666zM139.722 92.507h-1.666v1.666h1.666v-1.666zM141.388 92.507h-1.666v1.666h1.666v-1.666zM99.742 94.173h-1.666v1.666h1.666v-1.666zM106.406 94.173h-1.666v1.666h1.666v-1.666zM114.735 94.173h-1.666v1.666h1.666v-1.666zM116.4 94.173h-1.665v1.666h1.665v-1.666zM121.398 94.173h-1.666v1.666h1.666v-1.666zM124.73 94.173h-1.666v1.666h1.666v-1.666zM126.396 94.173h-1.666v1.666h1.666v-1.666zM129.727 94.173h-1.666v1.666h1.666v-1.666zM133.059 94.173h-1.666v1.666h1.666v-1.666zM134.725 94.173h-1.666v1.666h1.666v-1.666zM141.388 94.173h-1.666v1.666h1.666v-1.666zM143.054 94.173h-1.666v1.666h1.666v-1.666zM144.72 94.173h-1.666v1.666h1.666v-1.666zM101.408 95.839h-1.666v1.666h1.666v-1.666zM106.406 95.839h-1.666v1.666h1.666v-1.666z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M108.071 95.839h-1.665v1.666h1.665v-1.666zM109.737 95.839h-1.666v1.666h1.666v-1.666zM111.403 95.839h-1.666v1.666h1.666v-1.666zM113.069 95.839h-1.666v1.666h1.666v-1.666zM118.066 95.839h-1.665v1.666h1.665v-1.666zM119.732 95.839h-1.666v1.666h1.666v-1.666zM123.064 95.839h-1.666v1.666h1.666v-1.666zM124.73 95.839h-1.666v1.666h1.666v-1.666zM128.061 95.839h-1.665v1.666h1.665v-1.666zM129.727 95.839h-1.666v1.666h1.666v-1.666zM131.393 95.839h-1.666v1.666h1.666v-1.666zM141.388 95.839h-1.666v1.666h1.666v-1.666zM143.054 95.839h-1.666v1.666h1.666v-1.666zM144.72 95.839h-1.666v1.666h1.666v-1.666zM98.076 97.504h-1.665v1.666h1.665v-1.666zM99.742 97.504h-1.666v1.666h1.666v-1.666zM101.408 97.504h-1.666v1.666h1.666v-1.666zM103.074 97.504h-1.666v1.666h1.666v-1.666zM104.74 97.504h-1.666v1.666h1.666v-1.666z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M109.737 97.504h-1.666v1.666h1.666v-1.666zM111.403 97.504h-1.666v1.666h1.666v-1.666zM116.4 97.504h-1.665v1.666h1.665v-1.666zM121.398 97.504h-1.666v1.666h1.666v-1.666zM124.73 97.504h-1.666v1.666h1.666v-1.666zM136.391 97.504h-1.666v1.666h1.666v-1.666zM138.056 97.504h-1.665v1.666h1.665v-1.666zM143.054 97.504h-1.666v1.666h1.666v-1.666zM101.408 99.17h-1.666v1.666h1.666V99.17zM103.074 99.17h-1.666v1.666h1.666V99.17zM104.74 99.17h-1.666v1.666h1.666V99.17zM108.071 99.17h-1.665v1.666h1.665V99.17zM109.737 99.17h-1.666v1.666h1.666V99.17zM111.403 99.17h-1.666v1.666h1.666V99.17zM116.4 99.17h-1.665v1.666h1.665V99.17zM118.066 99.17h-1.665v1.666h1.665V99.17zM121.398 99.17h-1.666v1.666h1.666V99.17zM123.064 99.17h-1.666v1.666h1.666V99.17zM124.73 99.17h-1.666v1.666h1.666V99.17zM128.061 99.17h-1.665v1.666h1.665V99.17zM129.727 99.17h-1.666v1.666h1.666V99.17zM131.393 99.17h-1.666v1.666h1.666V99.17zM138.056 99.17h-1.665v1.666h1.665V99.17zM139.722 99.17h-1.666v1.666h1.666V99.17zM143.054 99.17h-1.666v1.666h1.666V99.17zM101.408 100.836h-1.666v1.666h1.666v-1.666zM106.406 100.836h-1.666v1.666h1.666v-1.666zM111.403 100.836h-1.666v1.666h1.666v-1.666zM113.069 100.836h-1.666v1.666h1.666v-1.666zM118.066 100.836h-1.665v1.666h1.665v-1.666zM121.398 100.836h-1.666v1.666h1.666v-1.666zM124.73 100.836h-1.666v1.666h1.666v-1.666zM128.061 100.836h-1.665v1.666h1.665v-1.666zM131.393 100.836h-1.666v1.666h1.666v-1.666zM136.391 100.836h-1.666v1.666h1.666v-1.666zM139.722 100.836h-1.666v1.666h1.666v-1.666zM141.388 100.836h-1.666v1.666h1.666v-1.666zM143.054 100.836h-1.666v1.666h1.666v-1.666zM98.076 102.502h-1.665v1.666h1.665v-1.666zM101.408 102.502h-1.666v1.666h1.666v-1.666zM104.74 102.502h-1.666v1.666h1.666v-1.666zM108.071 102.502h-1.665v1.666h1.665v-1.666zM109.737 102.502h-1.666v1.666h1.666v-1.666zM118.066 102.502h-1.665v1.666h1.665v-1.666zM119.732 102.502h-1.666v1.666h1.666v-1.666zM121.398 102.502h-1.666v1.666h1.666v-1.666zM123.064 102.502h-1.666v1.666h1.666v-1.666zM124.73 102.502h-1.666v1.666h1.666v-1.666zM126.396 102.502h-1.666v1.666h1.666v-1.666zM131.393 102.502h-1.666v1.666h1.666v-1.666zM134.725 102.502h-1.666v1.666h1.666v-1.666zM141.388 102.502h-1.666v1.666h1.666v-1.666zM101.408 104.168h-1.666v1.666h1.666v-1.666zM104.74 104.168h-1.666v1.666h1.666v-1.666zM106.406 104.168h-1.666v1.666h1.666v-1.666zM113.069 104.168h-1.666v1.666h1.666v-1.666zM114.735 104.168h-1.666v1.666h1.666v-1.666zM116.4 104.168h-1.665v1.666h1.665v-1.666zM119.732 104.168h-1.666v1.666h1.666v-1.666zM121.398 104.168h-1.666v1.666h1.666v-1.666zM126.396 104.168h-1.666v1.666h1.666v-1.666zM134.725 104.168h-1.666v1.666h1.666v-1.666zM136.391 104.168h-1.666v1.666h1.666v-1.666zM141.388 104.168h-1.666v1.666h1.666v-1.666zM99.742 105.833h-1.666v1.666h1.666v-1.666zM103.074 105.833h-1.666v1.666h1.666v-1.666z"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M108.071 105.833h-1.665v1.666h1.665v-1.666zM111.403 105.833h-1.666v1.666h1.666v-1.666zM113.069 105.833h-1.666v1.666h1.666v-1.666zM119.732 105.833h-1.666v1.666h1.666v-1.666zM121.398 105.833h-1.666v1.666h1.666v-1.666zM124.73 105.833h-1.666v1.666h1.666v-1.666zM126.396 105.833h-1.666v1.666h1.666v-1.666zM129.727 105.833h-1.666v1.666h1.666v-1.666zM131.393 105.833h-1.666v1.666h1.666v-1.666zM133.059 105.833h-1.666v1.666h1.666v-1.666zM134.725 105.833h-1.666v1.666h1.666v-1.666zM136.391 105.833h-1.666v1.666h1.666v-1.666zM138.056 105.833h-1.665v1.666h1.665v-1.666zM139.722 105.833h-1.666v1.666h1.666v-1.666zM141.388 105.833h-1.666v1.666h1.666v-1.666zM111.403 107.5h-1.666v1.665h1.666V107.5zM113.069 107.5h-1.666v1.665h1.666V107.5zM114.735 107.5h-1.666v1.665h1.666V107.5zM116.4 107.5h-1.665v1.665h1.665V107.5zM118.066 107.5h-1.665v1.665h1.665V107.5zM123.064 107.5h-1.666v1.665h1.666V107.5zM124.73 107.5h-1.666v1.665h1.666V107.5zM126.396 107.5h-1.666v1.665h1.666V107.5zM128.061 107.5h-1.665v1.665h1.665V107.5zM129.727 107.5h-1.666v1.665h1.666V107.5zM131.393 107.5h-1.666v1.665h1.666V107.5zM138.056 107.5h-1.665v1.665h1.665V107.5zM139.722 107.5h-1.666v1.665h1.666V107.5zM141.388 107.5h-1.666v1.665h1.666V107.5zM143.054 107.5h-1.666v1.665h1.666V107.5zM144.72 107.5h-1.666v1.665h1.666V107.5zM111.403 109.166h-1.666v1.665h1.666v-1.665zM118.066 109.166h-1.665v1.665h1.665v-1.665zM121.398 109.166h-1.666v1.665h1.666v-1.665zM123.064 109.166h-1.666v1.665h1.666v-1.665zM128.061 109.166h-1.665v1.665h1.665v-1.665zM129.727 109.166h-1.666v1.665h1.666v-1.665zM131.393 109.166h-1.666v1.665h1.666v-1.665zM134.725 109.166h-1.666v1.665h1.666v-1.665zM138.056 109.166h-1.665v1.665h1.665v-1.665zM139.722 109.166h-1.666v1.665h1.666v-1.665zM143.054 109.166h-1.666v1.665h1.666v-1.665zM111.403 110.831h-1.666v1.666h1.666v-1.666zM118.066 110.831h-1.665v1.666h1.665v-1.666zM119.732 110.831h-1.666v1.666h1.666v-1.666zM121.398 110.831h-1.666v1.666h1.666v-1.666zM123.064 110.831h-1.666v1.666h1.666v-1.666zM128.061 110.831h-1.665v1.666h1.665v-1.666zM131.393 110.831h-1.666v1.666h1.666v-1.666zM138.056 110.831h-1.665v1.666h1.665v-1.666zM139.722 110.831h-1.666v1.666h1.666v-1.666zM144.72 110.831h-1.666v1.666h1.666v-1.666zM113.069 112.497h-1.666v1.666h1.666v-1.666zM114.735 112.497h-1.666v1.666h1.666v-1.666zM116.4 112.497h-1.665v1.666h1.665v-1.666zM118.066 112.497h-1.665v1.666h1.665v-1.666zM124.73 112.497h-1.666v1.666h1.666v-1.666zM128.061 112.497h-1.665v1.666h1.665v-1.666zM131.393 112.497h-1.666v1.666h1.666v-1.666zM133.059 112.497h-1.666v1.666h1.666v-1.666zM134.725 112.497h-1.666v1.666h1.666v-1.666zM136.391 112.497h-1.666v1.666h1.666v-1.666zM138.056 112.497h-1.665v1.666h1.665v-1.666zM141.388 112.497h-1.666v1.666h1.666v-1.666zM144.72 112.497h-1.666v1.666h1.666v-1.666zM111.403 114.163h-1.666v1.666h1.666v-1.666zM114.735 114.163h-1.666v1.666h1.666v-1.666zM119.732 114.163h-1.666v1.666h1.666v-1.666zM131.393 114.163h-1.666v1.666h1.666v-1.666zM133.059 114.163h-1.666v1.666h1.666v-1.666zM138.056 114.163h-1.665v1.666h1.665v-1.666zM139.722 114.163h-1.666v1.666h1.666v-1.666zM143.054 114.163h-1.666v1.666h1.666v-1.666zM111.403 115.829h-1.666v1.665h1.666v-1.665zM113.069 115.829h-1.666v1.665h1.666v-1.665zM114.735 115.829h-1.666v1.665h1.666v-1.665zM116.4 115.829h-1.665v1.665h1.665v-1.665zM126.396 115.829h-1.666v1.665h1.666v-1.665zM128.061 115.829h-1.665v1.665h1.665v-1.665zM133.059 115.829h-1.666v1.665h1.666v-1.665zM136.391 115.829h-1.666v1.665h1.666v-1.665zM141.388 115.829h-1.666v1.665h1.666v-1.665zM144.72 115.829h-1.666v1.665h1.666v-1.665zM113.069 117.495h-1.666v1.665h1.666v-1.665zM114.735 117.495h-1.666v1.665h1.666v-1.665zM118.066 117.495h-1.665v1.665h1.665v-1.665zM119.732 117.495h-1.666v1.665h1.666v-1.665zM123.064 117.495h-1.666v1.665h1.666v-1.665zM126.396 117.495h-1.666v1.665h1.666v-1.665zM128.061 117.495h-1.665v1.665h1.665v-1.665zM129.727 117.495h-1.666v1.665h1.666v-1.665zM131.393 117.495h-1.666v1.665h1.666v-1.665zM133.059 117.495h-1.666v1.665h1.666v-1.665zM136.391 117.495h-1.666v1.665h1.666v-1.665zM138.056 117.495h-1.665v1.665h1.665v-1.665zM139.722 117.495h-1.666v1.665h1.666v-1.665zM143.054 117.495h-1.666v1.665h1.666v-1.665zM111.403 119.16h-1.666v1.666h1.666v-1.666zM116.4 119.16h-1.665v1.666h1.665v-1.666z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M126.396 119.16h-1.666v1.666h1.666v-1.666zM128.061 119.16h-1.665v1.666h1.665v-1.666zM129.727 119.16h-1.666v1.666h1.666v-1.666zM131.393 119.16h-1.666v1.666h1.666v-1.666zM134.725 119.16h-1.666v1.666h1.666v-1.666zM136.391 119.16h-1.666v1.666h1.666v-1.666zM143.054 119.16h-1.666v1.666h1.666v-1.666zM106.322 72.517H96.41V84.178H108.072V72.517h-1.749zm0 9.912H98.16v-8.163h8.162v8.163zM142.971 72.517h-9.912V84.178H144.72V72.517h-1.749zm0 9.912h-8.163v-8.163h8.163v8.163zM106.322 109.166H96.41V120.826H108.072V109.166h-1.749zm0 9.911H98.16v-8.162h8.162v8.162z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M104.74 75.849h-4.998v4.997h4.998V75.85zM141.388 75.849h-4.997v4.997h4.997V75.85zM104.74 112.497h-4.998v4.998h4.998v-4.998z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    stroke: "#7764F5",
    strokeMiterlimit: 10,
    strokeWidth: 0.773,
    d: "M102.185 67.1H92.097v11.174M138.873 67.1h10.085v11.174M102.185 125.943H92.097V114.77M138.873 125.943h10.085V114.77"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.386,
    d: "M71.49 69.522H68.14c-.592 0-1.073.482-1.073 1.077v9.414c0 .595.48 1.078 1.073 1.078h3.348c.593 0 1.073-.483 1.073-1.078V70.6c0-.595-.48-1.078-1.073-1.078z"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.386,
    d: "M72.072 70.543H67.55v9.523h4.522v-9.523zM23.354 126.218a8.656 8.656 0 0 0 4.558-1.327c-.088 2.574-.157 4.523-.157 4.523s.442.775.663 1.11c.221.335 2.098 1.441 2.32 2.441.22 1.001 1.205 1.554 1.105 2.995-.1 1.44-1.327-.113-1.105.222.22.334.884 1.44.884 2.441s-2.098.997-2.874.331c-.776-.666-3.312-2.22-3.533-3.66l-.864-3.229-.997-5.847z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M27.944 134.22l.539 2.421s1.74 1.344 1.873 2.288"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.386,
    d: "M27.944 134.22l.539 2.421s1.74 1.344 1.873 2.288M30.733 136.181l-.78-1.557"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.386,
    d: "M36.63 185.376s-.631 5.194-.14 5.827a3.688 3.688 0 0 0 2.374 1.53c1.118.141 3.007-.493 3.007-.493 1.275.344 2.6.463 3.915.351 2.01-.21 3.352-.98 3.493-1.965.14-.985-1.608-1.4-2.585-2.453-.977-1.054-2.536-2.918-2.536-2.918l-.402-1.364s-2.375 1.211-3.91 1.263a9.23 9.23 0 0 1-2.59-.21l-.626.432z"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.386,
    d: "M49.279 190.638a.754.754 0 0 0-.033-.343c-.462.194-1.053.428-1.784.694-2.098.775-3.147.142-4.192.142-1.045 0-1.122 1.121-4.056.351-1.917-.505-2.636-1.154-2.91-1.55-.038.433.025.868.185 1.271a3.688 3.688 0 0 0 2.376 1.53c1.117.141 3.006-.493 3.006-.493 1.275.344 2.6.463 3.915.351 2.026-.197 3.352-.968 3.493-1.953z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    fill: "#737373",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.386,
    d: "M32.904 120.904s-2.814 9.483-1.809 16.141c1.005 6.659 5.828 19.168 5.828 19.168s-.603 4.641-.603 6.255c0 1.614-1.407 4.641-.402 7.869 1.005 3.228 1.005 11.702 1.005 12.308 0 .605-.402 3.833-.402 3.833s.804 1.211 3.819 1.211c3.014 0 3.818-2.421 3.818-2.421s3.014-17.958 3.014-20.782c0-2.825 3.216-13.317 4.422-17.554a36.221 36.221 0 0 1 3.476-8.345c.804-1.413.342-18.49.342-18.49l-22.91-2.018.402 2.825z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.386,
    d: "M48.72 186.712s3.006 1.19 4.473 1.892c1.467.703 2.444.771 2.444 1.897s-2.653 2.244-4.26 2.526c-1.608.283-4.197.21-4.474.279-.277.068-5.522.843-6.15-.493-.626-1.335.069-5.891.069-5.891 2.62.449 5.304.378 7.898-.21z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.386,
    d: "M46.903 193.306c.278-.069 2.866 0 4.474-.279 1.607-.278 4.26-1.404 4.26-2.526a1.446 1.446 0 0 0-.064-.436c-.679.398-1.38.754-2.102 1.066-1.958.843-4.542 1.404-8.44 1.335a17.947 17.947 0 0 1-4.478-.577c.022.318.095.63.217.925.61 1.335 5.852.564 6.133.492z"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    fill: "#737373",
    d: "M55.613 121.71s1.206 16.344-1.206 28.651c-2.411 12.308-6.43 29.055-6.632 29.862-.2.807 1.407 3.026 1.407 3.026v3.229s-1.407 1.412-4.622 1.816c-3.216.403-4.22-.606-4.22-.606s-.804-5.447-.804-9.281c0-3.834.804-16.948.804-16.948s1.808-13.317 1.607-15.335c-.2-2.017-.804-8.272-.804-8.272l-3.215-3.834"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.386,
    d: "M55.613 121.71s1.206 16.344-1.206 28.651c-2.411 12.308-6.43 29.055-6.632 29.862-.2.807 1.407 3.026 1.407 3.026v3.229s-1.407 1.412-4.622 1.816c-3.216.403-4.22-.606-4.22-.606s-.804-5.447-.804-9.281c0-3.834.804-16.948.804-16.948s1.808-13.317 1.607-15.335c-.2-2.017-.804-8.272-.804-8.272l-3.215-3.834"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.386,
    d: "M21.83 118.636l6.323-1.114c-.028.859.153-4.572.153-4.976 0-.887 2.098-6.456 2.098-6.456s1.656 7.215 1.656 8.103c0 .888-.663 7.667.22 8.543.885.875 3.98 2.663 10.833 2.441 6.853-.222 11.937-.779 13.264-2.11 1.326-1.332-.221-5.436-.334-5.989-.112-.553 1.769-15.092 1.769-15.092s7.403 7.768 11.824 6.658c4.422-1.11 2.324-18.41 2.324-18.41l.22-4.99s1.436-3.66 1.436-4.218c0-.557-1.435-4.548-1.435-4.548s-.885-.778-1.44 1.11a18.267 18.267 0 0 0-.662 3.107s-1.327.997-1.206 2.442c.066.871.251 1.73.55 2.55l-2.99 9.794s-3.316-3.773-3.537-4.439c-.221-.666-.113-3.107-2.874-4.552-2.761-1.444-8.4-1.553-8.4-1.553l-15.583.112s-7.295.646-8.931 2.087c-1.636 1.44-6.74 19.753-6.74 22.525 0 .868.45 3.555 1.08 6.88l.383 2.095z"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.386,
    d: "M72.18 76.486s-.333 2.773-.112 3.33c.317.964.393 1.992.221 2.994"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.386,
    d: "M69.636 108.664c4.422-1.109 2.324-18.421 2.324-18.421l.048-1.118a3.986 3.986 0 0 0-3.433-.682l-2.142 7.038s-3.316-3.773-3.537-4.439c-.221-.666-.113-3.107-2.874-4.552-2.761-1.444-8.4-1.553-8.4-1.553l-15.583.112s-7.295.646-8.931 2.087c-1.636 1.44-6.74 19.753-6.74 22.525 0 1.647 1.631 9.854 3.006 16.545a8.648 8.648 0 0 0 4.538-1.316c.16-4.798.402-11.767.402-12.344 0-.887 2.098-6.456 2.098-6.456s1.656 7.215 1.656 8.103c0 .888-.663 7.667.22 8.543.885.875 3.98 2.663 10.833 2.441 6.853-.222 11.937-.779 13.264-2.11 1.326-1.332-.221-5.436-.334-5.989-.112-.553 1.769-15.092 1.769-15.092s7.395 7.788 11.816 6.678z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.386,
    d: "M28.233 100.005l2.17 6.105-4.469-7.671M27.008 96.559l.767 2.159M42.313 100.437c.977 2.203 2.412 4.967 4.12 6.747M40.943 96.962s.301.908.84 2.227M43.354 104.359s2.412 4.842 3.617 5.783M61.594 98.487l.916-.855M60.099 97.228l-2.287 4.778 2.95-2.744M70.549 99.92c-.133-.94-4.116-4.46-4.116-4.46s4.116 1.635 5.189 3.116"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.386,
    d: "M53.17 70.381s.22 2.777.554 3.228c.334.453.55 3.883 0 4.883-.55 1.001-.884 2.22-1.206 2.55-.321.332-1.547.336-2.01.336-.462 0-5.414-.222-5.414-.222l.113-6.994s1.222-5.221 7.962-3.78z"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.386,
    d: "M44.33 62.617s-4.533 1.44-5.526 5.424c-.992 3.982 2.21 8.542 2.21 8.542s.885 3.229 1.657 3.886c.772.658 3.866 0 4.863-.221.997-.223 3.216-6.215 3.216-6.215s0 1.44.663 1.44.555-1.884.555-2.219c0-.335 3.094-2.663 3.094-6.654s-3.436-5.758-6.651-5.536c-3.216.221-4.08 1.553-4.08 1.553z"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.386,
    d: "M53.724 84.695s-.663-2.329-.997-2.66c-.333-.33-2.431-1.666-5.856-1.888-3.424-.222-8.509-.11-8.951.113-.442.222-.555 2.106-.555 2.106s-1.435 1.332-1.768 2.11c-.334.78-.663 1.106 2.411 3.66 3.075 2.555 4.755 3.552 7.959 2.773 3.203-.779 7.845-5.436 7.845-5.436l-.088-.778z"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.386,
    d: "M45.818 86.268a33.412 33.412 0 0 0 6.246-2.893M37.365 82.81s2.01 3.995 5.527 3.995c.48-.006.957-.057 1.427-.153"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformation1);
export default __webpack_public_path__ + "static/media/information_1.12e3b7ef654ca25d1d2ee93cb35ae993.svg";
export { ForwardRef as ReactComponent };